import { Component, OnInit, OnDestroy } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToasterService } from '../services/toaster.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-add-policy',
  templateUrl: './add-policy.component.html',
  styleUrls: ['./add-policy.component.css'],
  providers: [ToasterService]
})
export class AddPolicyComponent implements OnInit, OnDestroy {

  data: any = {insurer: null, productName: null};
  loading: boolean;
  uploading: boolean = false;

  productList: any[] = [];
  insurerList: any[] = [];

  uploadedFileUrl: string = '';

  renewalDateRequired: boolean;
  currentDate: Date = new Date();

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private serviceURLService: serviceURLService,
    private http: HttpClient,
    private toasterService: ToasterService
  ) {}

  ngOnInit() {
    this.getProductList();
    this.getInsurerList();
  }

  // ✅ PRODUCT LIST API
  getProductList() {
  this.http.get('https://securenow.in/pam/api/v1/rm/all-product-list')
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((res: any) => {

      const dataObj = res?.data || {};

      // ✅ Convert object to array
      this.productList = Object.keys(dataObj).map(key => ({
        id: key,
        name: dataObj[key]
      }));

      console.log('Product List:', this.productList);

    });
}

  getInsurerList() {
  this.http.get('https://securenow.in/admin/api/v1/insurer/getAll-insurerList?sort=DESC&size=300&page=0&search=')
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((res: any) => {

      const insurerDtos = res?.data?.insurerDtos || [];

      const uniqueMap = new Map();

      this.insurerList = insurerDtos
        .filter(ins => ins.code) // ✅ remove null code
        .filter(ins => {
          if (uniqueMap.has(ins.name)) return false; // ✅ unique by name
          uniqueMap.set(ins.name, true);
          return true;
        });

    });
}
  

  // ✅ FILE CHANGE
  onFileChanged(event) {
    const file = event.target.files[0];
    if (!file) return;

    const supportedExtensions = ['jpeg', 'jpg', 'png', 'pdf', 'xls', 'xlsx'];
    const extension = file.name.split('.').pop().toLowerCase();

    if (!supportedExtensions.includes(extension)) {
      this.showToast("Invalid file type", "error");
      return;
    }

    if (file.size < 10000 || file.size > 15000000) {
      this.showToast("File should be 10KB to 15MB", "error");
      return;
    }

    this.uploadFile(file);
  }

  // ✅ FILE UPLOAD API
  uploadFile(file: File) {
    this.uploading = true;

    const formData = new FormData();
    formData.append('file', file);

    this.http.post('https://securenow.in/profession/api/v1/notify-excel-upload', formData)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res: any) => {
        this.uploading = false;
        this.uploadedFileUrl = res?.data?.[1];
        this.showToast("File uploaded successfully", "success");
      }, () => {
        this.uploading = false;
        this.showToast("Upload failed", "error");
      });
  }

  // ✅ SAVE POLICY
  addPolicyDetails() {
    this.loading = true;

    var userId = localStorage.getItem("userID");

    const policyData = {
      name: localStorage.getItem("name"),
      policyName: this.data.productName?.name || this.data.productName,
      cardNo: this.data.cardNo || "",
      email: localStorage.getItem("email"),
      mobile: localStorage.getItem("mobileNumber"),
      description: "",
      age: "",
      gender: "",
      policyStartDate: new Date(this.data.policyStartDate).getTime(),
      policyEndDate: new Date(this.data.renewalDate).getTime(),
      premiumPaid: this.data.premium,
      sumInsured: this.data.sumInsured,
      policyNumber: this.data.policyNumber,
      Insurer: this.data.insurer?.name || this.data.insurer,
      productName: this.data.productName?.name || this.data.productName,
      policyHolder: this.data.holderName,
      attachment: this.uploadedFileUrl,
      insurerCode: this.data.insurer?.code,
    };

    this.serviceURLService.addPolicies(policyData, userId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((successData: any) => {
        this.loading = false;
        this.showToast(successData.message, "success");

        setTimeout(() => {
          this.router.navigate(['home']);
        }, 3000);
      }, (errorData) => {
        this.loading = false;
        this.showToast(errorData.message, "error");
      });
  }

  checkEmpty() {
    this.renewalDateRequired = !this.data.renewalDate;
  }

  checkValue() {
    this.renewalDateRequired = !this.data.renewalDate;
  }

  // ✅ TOASTER
  showToast(message: string, type: string = 'default') {
  const toaster = document.getElementById("snackbar");

  if (!toaster) return;

  toaster.innerHTML = message;

  // reset classes
  toaster.className = '';

  // add show + type
  toaster.classList.add('show');
  if (type !== 'default') {
    toaster.classList.add(type);
  }

  setTimeout(() => {
    toaster.className = toaster.className.replace("show", "");
  }, 3000);
}

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}